import { ajaxService, urlService } from "../services";
import { Response } from "../utility";

const removeDependency = () => { ajaxService.removeDependency() }

export async function getMarketplaceCustomers() {
    removeDependency()
    return ajaxService.get(urlService.marketplaceCustomers).then(response => {
        return Response(response.data);
    })
}

export async function getMarketplaceCustomer(id) {
    removeDependency()
    return ajaxService.get(`${urlService.marketplaceCustomers}/${id}`).then(response => {
        return Response(response.data);
    })
}

export async function filterMarketplaceCustomers(data) {
    removeDependency()
    return ajaxService.post(urlService.marketplaceCustomersFilter, data).then(response => {
        return Response(response.data);
    })
}
